import {
  Activity,
  ArrowRightLeft,
  BarChart3,
  BookOpen,
  Building,
  Building2,
  ClipboardList,
  Factory,
  FileBarChart,
  FileSignature,
  FileSpreadsheet,
  FolderTree,
  Handshake,
  KeySquare,
  LayoutDashboard,
  LineChart,
  Link,
  ListTree,
  Map as MapIcon,
  MapPin,
  Menu,
  Package,
  PackagePlus,
  PieChart,
  Plug,
  QrCode,
  Scale,
  ScanLine,
  ScrollText,
  Settings,
  ShieldCheck,
  ShoppingCart,
  Star,
  Tag,
  Ticket,
  TicketPlus,
  TrendingUp,
  Users,
} from 'lucide-react'
import { createElement } from 'react'

// khớp tên icon gán trong buildMenuFromTabs.ts (MODULE_ICON và CATEGORY_ICON)
// Map alias MapIcon để không shadow global Map (biome noShadowRestrictedNames)
const ICON_MAP: Record<string, typeof Package> = {
  Activity,
  ArrowRightLeft,
  BarChart3,
  BookOpen,
  Building,
  Building2,
  ClipboardList,
  Factory,
  FileBarChart,
  FileSignature,
  FileSpreadsheet,
  FolderTree,
  Handshake,
  KeySquare,
  LayoutDashboard,
  LineChart,
  Link,
  ListTree,
  Map: MapIcon,
  MapPin,
  Menu,
  Package,
  PackagePlus,
  PieChart,
  Plug,
  QrCode,
  Scale,
  ScanLine,
  ScrollText,
  Settings,
  ShieldCheck,
  ShoppingCart,
  Star,
  Tag,
  Ticket,
  TicketPlus,
  TrendingUp,
  Users,
}

export const getMenuIcon = (name?: string) =>
  name && ICON_MAP[name] ? createElement(ICON_MAP[name], { size: 16 }) : undefined
